import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../../services/newUserService";
import { handleErrors } from "../../utils/errorHandler";

const getCurrentDate = () =>
  new Date().toLocaleDateString("en-GB", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

export const DashboardIntro = () => {
  const [userName, setUserName] = useState();
  const [roleName, setRoleName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await fetchUserProfile();
        const result = userData.data.result;
        setRoleName(result.roleName || result.RoleName || "");
        setUserName(result.userName);
      } catch (error) {
        handleErrors(error);
      }
    };

    fetchUserData();
  }, [navigate]);

  return (
    <div className="xc-welcome dash-fade">
      <div className="xc-welcome__left">
        <p className="xc-welcome__eyebrow">Dashboard</p>
        <h4 className="xc-welcome__title">
          Welcome Back, <span>{userName || "Admin"}</span>
        </h4>
      </div>
      <div className="xc-welcome__pills">
        {roleName && (
          <span className="xc-welcome__pill xc-welcome__pill--role">
            <i className="ri-shield-user-line" aria-hidden="true" />
            {roleName}
          </span>
        )}
        <span className="xc-welcome__pill">
          <i className="ri-calendar-2-line" aria-hidden="true" />
          {getCurrentDate()}
        </span>
      </div>
    </div>
  );
};
